import React from 'react';
import glowImg from '../../images/smart-summary/coupon-glow.svg';

/**
 * Pre-applied coupon banner. Discount artwork is the backend `discountImg`
 * (rendered only when present). Coupon code is the backend `couponTxt`.
 * Renders nothing if there is no coupon code.
 */
export default function CouponBanner({ couponTxt = '', discountImg = '' }) {
  if (!couponTxt) return null;

  return (
    <div className="ssbs__coupon">
      <img
        className="ssbs__coupon-glow"
        src={glowImg}
        alt=""
        aria-hidden="true"
      />
      {discountImg && (
        <div className="ssbs__coupon-art">
          <img src={discountImg} alt="" className="ssbs__coupon-art-img" />
        </div>
      )}

      <div className="ssbs__coupon-info">
        <div className="ssbs__coupon-row">
          <span className="ssbs__coupon-preapplied">Pre-applied</span>
          <span className="ssbs__coupon-code">{couponTxt}</span>
        </div>
        <span className="ssbs__coupon-claim">Claim your discount now</span>
      </div>
    </div>
  );
}
